import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@constants/queryKey';
import { minutesToMillis } from '@utils/millis';
import { FetchMaintenanceMessageError, FetchMaintenanceMessageResponse } from '@models/maintenanceMessage/FetchMaintenanceMessage';
import { fetchMaintenanceMessage } from '@repository/maintenanceMessageRepository';

const useFetchMaintenanceMessage = () => {
    return useQuery<FetchMaintenanceMessageResponse, FetchMaintenanceMessageError>({
        queryKey: [QueryKey.MaintenanceMessage],
        queryFn: ({ signal }) => fetchMaintenanceMessage({ signal }),
        staleTime: minutesToMillis(30),
    });
};

export default useFetchMaintenanceMessage;
